export default __webpack_public_path__ + "static/media/user_profile.cb60b00d.svg";